import React from 'react';
import ObservatoryDetailsBase from '../../components/common/ObservatoryDetailsBase';

function ObservatoryDetail() {
  return (
    <ObservatoryDetailsBase 
      mode="user"
      enableEditMode={false}
      enableMemberManagement={false}
      backRoute="/observatories"
    />
  );
}

export default ObservatoryDetail;